export const groupBy = (list: any[], key: any): Map<any, any> => {
  const map = new Map();

  list.forEach((item) => {
    if (item.hasOwnProperty(key)) {
      const value = item[key];
      const collection = map.get(value);
      if (collection) {
        collection.push(item);
      } else {
        map.set(value, [item]);
      }
    }
  });

  return map;
};

export const isValidArray = (array: any): boolean => array && Array.isArray(array);
export const isEmptyArray = (array: any): boolean => isValidArray(array) && array.length === 0;
export const isNotEmptyArray = (array: any): boolean => isValidArray(array) && array.length > 0;
